/**
 * Validates if a ticker symbol represents a valid US stock.
 * Filters out ADRs, warrants, and other non-US securities.
 *
 * @param ticker - The stock ticker symbol to validate
 * @returns true if the ticker is a valid US stock symbol, false otherwise
 */
export const isValidUSStockSymbol = (ticker: string): boolean => {
  if (!ticker || typeof ticker !== 'string') return false;

  // Remove whitespace
  const cleanTicker = ticker.trim().toUpperCase();

  // Must be 1-5 characters
  if (cleanTicker.length === 0 || cleanTicker.length > 5) return false;

  // Must not contain periods (ADRs, warrants, etc.)
  if (cleanTicker.includes('.')) return false;

  // Must contain only letters
  if (!/^[A-Z]+$/.test(cleanTicker)) return false;

  return true;
};
